import validateExperimentConfig from "./validateExperimentConfig";

/**
 * Currently running experiments that can be correlated to Optimize Experiments.
 *
 * Object should be formatted as below:
 * @example
 * export const OPTIMIZE_EXPERIMENTS: OptimizeExperiments = {
 * "my-awesome-test": {
 *   id: "optimize_id",
 *   groups: ["control", "variant"]
 *  }
 * };
 * @link https://atlanticmedia.atlassian.net/wiki/spaces/DSO/pages/189759541/A+B+Testing#A/BTesting-AddingConfigurationinAccounts
 */
//
export const OPTIMIZE_EXPERIMENTS = {
  "recirc-source": {
    id: "MzjERchsQwy7Y7PCiN-RdQ",
    groups: ["control", "datascience"],
  },
  "Three-Article-Meter-Holdout": {
    id: "ftk0vjqISumre-ANkIeXzw",
    groups: ["control", "3ArticleLimit"],
  },
  "Text-Only-Recommended-Reading": {
    id: "vOvqd6JeRbC1iJ1rci3rvQ",
    groups: ["control", "authors", "no-authors", "hidden"],
  },
} as const;

/**
 * This can be an array of up to length 19 where the indexes represent
 * CDN-created experiment buckets.
 *
 * Object should be formatted as below:
 * @example
 * export const OPTIMIZE_BUCKETS: OptimizeBuckets = [
 *   "my-awesome-test.control",
 *   "my-awesome-test.test",
 * ];
 * Or
 * @example
 * export const OPTIMIZE_BUCKETS: OptimizeBuckets = {
 *   0: "my-awesome-test.control",
 *   5: "my-awesome-test.test",
 *   7: "my-awesome-test.variant",
 * }
 *
 * @link https://atlanticmedia.atlassian.net/wiki/spaces/DSO/pages/189759541/A+B+Testing#A/BTesting-AddingConfigurationinAccounts
 */
export const OPTIMIZE_BUCKETS = {
  0: "control",
  6: "recirc-source.datascience",
  8: "Three-Article-Meter-Holdout.3ArticleLimit",
  3: "Text-Only-Recommended-Reading.authors",
  4: "Text-Only-Recommended-Reading.no-authors",
  7: "Text-Only-Recommended-Reading.hidden",
} as const;

validateExperimentConfig(OPTIMIZE_EXPERIMENTS, OPTIMIZE_BUCKETS);
